import React from "react";
import "./download.css";
import Link from "next/link";

export default function Download() {
  return (
    <section>
      <div id="download-anchor" className="download-cont">
        <img
          src="./images/download-app-mockups.png"
          alt="Download OFFBEAT App Now"
          width="500px"
        ></img>
        <div className="download-text">
          <h2>Download the App now!</h2>
          <p>Stay up to date on your benefits</p>
          <Link
            href="https://apps.apple.com/za/app/off-beat-plus/id6737212221"
            target="_blank"
          >
            <img
              src="./images/apple-app-store-logo.png"
              alt="Download on the App Store"
            ></img>
          </Link>
          <Link
            href="https://play.google.com/store/apps/details?id=za.co.firstloyaltyplus.offbeatplus&hl=en"
            target="_blank"
          >
            <img
              src="./images/google-play-badge.png"
              alt="Get it on Google Play"
            ></img>
          </Link>
        </div>
      </div>
    </section>
  );
}
